/*
 * @Description:
 * @Author: tongjunyi<tongjunyi@didiglobal.com>
 * @Date: 2023-08-11 13:21:34
 * @LastEditors: tongjunyi
 * @LastEditTime: 2023-11-18 13:39:00
 */
import { API_URL } from '@/api/url';
import { Http } from '@/lib/http';

import { GetOrderSummaryRes } from './fuelOrder.type';
// import { ExportBillParams } from '@/api/typings';
export class FuelOrderApi {
  /**
   * 查询订单汇总
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/770682
   */
  static getOrderSummary = (params: any) => {
    return Http<GetOrderSummaryRes>({
      method: 'GET',
      url: API_URL.GetOrderSummary,
      params
    });
  };

  /**
   * 根据检索条件获取订单
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/768597
   */
  static getOrderList = (params: any) => {
    return Http({
      method: 'GET',
      url: API_URL.GetOrderList,
      params
    });
  };
}

export default FuelOrderApi;
